import { ACTION_TYPES } from "../actions/types";

const initialState = {
  exportCount: 0,
  exportError: null,
  hasSearched: false,
  isFetchingExport: false,
  isDownloadingExport: false,
  timeUnit: "seconds", // "seconds" or "minutes"
};

export default function exportReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.EXPORT_COUNT:
      return {
        ...state,
        exportCount: action.payload,
        exportError: null,
        hasSearched: true,
      };

    case ACTION_TYPES.EXPORT_COUNT_ERROR:
      return {
        ...state,
        exportCount: 0,
        exportError: action.payload,
        hasSearched: true,
      };

    case ACTION_TYPES.UPDATE_IS_FETCHING_EXPORT:
      return {
        ...state,
        isFetchingExport: action.payload,
      };

    case ACTION_TYPES.UPDATE_IS_DOWNLOADING_EXPORT:
      return {
        ...state,
        isDownloadingExport: action.payload,
      };

    case ACTION_TYPES.RESET_EXPORT_STATE:
      return {
        ...state,
        exportCount: 0,
        exportError: null,
        hasSearched: false,
      };

    case ACTION_TYPES.SET_EXPORT_TIME_UNIT:
      return {
        ...state,
        timeUnit: action.payload,
      };

    default:
      return state;
  }
}
